<template>
  <el-select
    ref="searchTestSelector"
    v-model="searchInput"
    placeholder="Search Test..."
    class="search-test-selector"
    popper-class="search-test-selector-dropdown"
    filterable
    :filter-method="debounceSearchTest"
    value-key="id"
    @change="handleChangeEvent"
    @focus="initializeSearchTest"
    @visible-change="blurOnSelector"
  >
    <el-option-group
      v-for="group in filteredTestOptions"
      :key="group.label"
      :label="group.label"
    >
      <el-option
        v-for="item in group.options"
        :key="item.id"
        :value="item"
        :label="item.name"
      />
    </el-option-group>
  </el-select>
</template>

<script>
import _ from "lodash";

export default {
  emits: [ "change", "focus" ],
  props: {
    testOptions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      searchInput: null,
      filteredTestOptions: [],
    }
  },

  created() {
    this.debounceSearchTest = _.debounce(this.searchTest, 700);
  },

  methods: {
    searchTest(queryString) {
      if (!queryString) {
        return;
      }
      this.searchInput = queryString;
      this.filteredTestOptions = [];
      let input = queryString.trim().toLowerCase();
      if (input === "") {
        return;
      }
      this.testOptions.forEach((testOption) => {
        let filteredOptions = testOption.options.filter((t) =>
          t.name && t.name.toLowerCase().includes(input)
        );
        if (filteredOptions.length > 0) {
          this.filteredTestOptions.push({
            label: testOption.label,
            options: filteredOptions,
          });
        }
      });
    },

    handleChangeEvent(item) {
      this.$emit("change", item);
    },

    initializeSearchTest() {
      this.searchInput = null;
      this.filteredTestOptions = [];
      this.$emit("focus");
    },

    // make search test selector blured when dropdown is disappeared
    blurOnSelector(isDropdownDisplay) {
      setTimeout(() => {
        if (!isDropdownDisplay && this.$refs.searchTestSelector) {
          this.$refs.searchTestSelector.blur();
        }
      }, 50);
    },
  }
}
</script>

<style scoped>
/* Search input styling - match "Name your bundle" style */
.search-test-selector :deep(.el-select__wrapper) {
  width: 100% !important;
  height: 42px !important;
  min-height: 42px !important;
  padding: 0 12px 0 12px !important;
  border: 1px solid #C9CACD !important;
  border-radius: 4px !important;
  background: #fff !important;
  box-shadow: none !important;
}

.search-test-selector :deep(.el-select__wrapper .el-select__input) {
  height: 40px !important;
  line-height: 40px !important;
  font-size: 16px !important;
  font-family: 'Inter', sans-serif !important;
  color: #333 !important;
}

.search-test-selector :deep(.el-select__placeholder) {
  height: 40px !important;
  line-height: 40px !important;
  font-size: 16px !important;
  font-family: 'Inter', sans-serif !important;
  color: #999 !important;
}

.search-test-selector :deep(.el-select__wrapper.is-focus),
.search-test-selector :deep(.el-select__wrapper:hover) {
  border-color: #004879 !important;
}
</style>
